module.exports = __webpack_public_path__ + "static/wp-logo-bottom-10d78443356f5bf534397d862506dc5b.png";